import {
  AuthProtectedRoute,
  AuthProtectedComponent,
} from '@statsbomb/kitbag-auth';

import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { useAuthDetails } from '../../utils/auth';
import { CLAIMS_URI } from '../../AuthProvider';

const Component = ({ children }) => children;

export function SecuredRoute({ allowed, children, exact, path }) {
  const { isLoading, isAuthenticated, handleLogin } = useAuthDetails();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      handleLogin();
    }
  }, [isAuthenticated, isLoading]);

  return (
    <Route
      component={<AuthProtectedRoute element={<Component />} />}
      exact={exact}
      path={path}
    >
      <AuthProtectedComponent allowed={allowed} claimsURI={CLAIMS_URI}>
        {children}
      </AuthProtectedComponent>
    </Route>
  );
}

SecuredRoute.propTypes = {
  allowed: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.node.isRequired,
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired,
};

SecuredRoute.defaultProps = {
  allowed: undefined,
  exact: false,
};

export default SecuredRoute;
